import moment from "moment";
export class Qdatepicker {
  constructor(el) {
    let index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let options = arguments.length > 2 ? arguments[2] : undefined;
    this.indexDatePicker = index;
    this.$root = el.parentNode.parentNode;
    this.$root.id = `root_datepicker-${index}`;
    this.$box = el.parentNode.parentNode;
    this.$input = el;
    this.$input.setAttribute("maxlength", 10);
    this.separator = this.$input.dataset.separator || ".";
    this.classShow = false;
    this.minDate = false;
    this.maxDate = false;
    this.messages = options.messages;
    // Минимальная дата
    if (this.$input.getAttribute('min')) {
      const date = new Date(this.$input.getAttribute('min'));
      this.minDate = {
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDay(),
        date: date
      };
    }
    // Максимальная дата
    if (this.$input.getAttribute('max')) {
      const date = new Date(this.$input.getAttribute('max'));
      this.maxDate = {
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDay(),
        date: date
      };
    }
    this.date = this.$input.value ? new Date(this.$input.value) : new Date(); // 2020, 1, 3
    this.dateInput = this.$input.value ? new Date(this.$input.value) : new Date(); // Дата в value
    this.parseSetDate();
    this.listeners = {}; // события

    this.inputMask = "";
    this.weekDayCurrent = this.date.getDay(); // индекс дня недели текущей даты
    this.view = "day"; // day, month, year
    this.weekDaysName = [this.messages.mo, this.messages.tu, this.messages.wd, this.messages.th, this.messages.fr, this.messages.st, this.messages.su];
    this.monthName = [this.messages.january, this.messages.february, this.messages.march, this.messages.april, this.messages.ma, this.messages.jun, this.messages.jul, this.messages.august, this.messages.september, this.messages.october, this.messages.november, this.messages.december];
    this.monthShortName = [this.messages.jan, this.messages.feb, this.messages.mar, this.messages.apr, this.messages.may, this.messages.june, this.messages.july, this.messages.aug, this.messages.sept, this.messages.oct, this.messages.nov, this.messages.dec];
    this.shiftYear = 0;
    this.updateData(true);
  }
  toHtml() {
    return `
      <i class="qform-field__block_box__field__view_pointer"></i>
      <nav
        class="qform-field__block_box__field__view_nav-top"
        id="navTop_${this.indexDatePicker}">
      </nav>
      <div class="qform-field__block_box__field__view_content">
        <div id="datepickerDay_${this.indexDatePicker}" class="datepicker__days datepicker__body"></div>
        <div id="datepickerMonths_${this.indexDatePicker}" class="datepicker__months datepicker__body"></div>
        <div id="datepickerYears_${this.indexDatePicker}" class="datepicker__years datepicker__body"></div>
      </div>
      <nav class="qform-field__block_box__field__view_nav-bottom">${this.bottomNavToHtml()}</nav>
    `;
  }
  getNumbersDay() {
    let prevDays = 0,
      nextDays = 0,
      daysArr = [];
    this.weekDayStart > 0 ? prevDays = this.weekDayStart - 1 : prevDays = 6;
    this.weekDayEnd < 7 && this.weekDayEnd > 0 ? nextDays = 7 - this.weekDayEnd : null;
    let disabled = "";

    // Предыдущий месяц
    for (let i = prevDays; i > 0; i--) {
      if (this.minDate) {
        disabled = this.minDate.date > new Date(this.monthCurrent === 0 ? this.yearCurrent - 1 : this.yearCurrent, this.monthCurrent === 0 ? 11 : this.monthCurrent - 1, this.maxDayPrev - i + 1) ? " -disabled-" : "";
      }
      if (this.maxDate && disabled.length === 0) {
        disabled = this.maxDate.date < new Date(this.monthCurrent === 0 ? this.yearCurrent - 1 : this.yearCurrent, this.monthCurrent === 0 ? 11 : this.monthCurrent - 1, this.maxDayPrev - i + 1) ? " -disabled-" : "";
      }
      daysArr.push({
        day: this.maxDayPrev - i + 1,
        month: this.monthCurrent === 0 ? 11 : this.monthCurrent - 1,
        year: this.monthCurrent === 0 ? this.yearCurrent - 1 : this.yearCurrent,
        class: "-other-month-" + disabled
      });
    }

    // Текущий месяц
    for (let i = 0; i < this.maxDayCurrent; i++) {
      if (this.minDate) {
        disabled = this.minDate.date > new Date(this.yearCurrent, this.monthCurrent, i + 1) ? " -disabled-" : "";
      }
      if (this.maxDate && disabled.length === 0) {
        disabled = this.maxDate.date < new Date(this.yearCurrent, this.monthCurrent, i + 1) ? " -disabled-" : "";
      }
      daysArr.push({
        day: i + 1,
        month: this.monthCurrent,
        year: this.yearCurrent,
        class: this.dateInput.getDate() === i + 1 && this.dateInput.getMonth() === this.monthCurrent && this.dateInput.getFullYear() === this.yearCurrent ? "-selected-" + disabled : "" + disabled
      });
    }

    // Следующий месяц
    for (let i = 0; i < nextDays; i++) {
      if (this.minDate) {
        disabled = this.minDate.date > new Date(this.monthCurrent === 11 ? this.yearCurrent + 1 : this.yearCurrent, this.monthCurrent === 11 ? 0 : this.monthCurrent + 1, i + 1) ? " -disabled-" : "";
      }
      if (this.maxDate && disabled.length === 0) {
        disabled = this.maxDate.date < new Date(this.monthCurrent === 11 ? this.yearCurrent + 1 : this.yearCurrent, this.monthCurrent === 11 ? 0 : this.monthCurrent + 1, i + 1) ? " -disabled-" : "";
      }
      daysArr.push({
        day: i + 1,
        month: this.monthCurrent === 11 ? 0 : this.monthCurrent + 1,
        year: this.monthCurrent === 11 ? this.yearCurrent + 1 : this.yearCurrent,
        class: "-other-month-" + disabled
      });
    }
    return daysArr;
  }
  dayToHtml() {
    let daysArr = this.getNumbersDay();
    // дни недели
    let makeupWeekDays = ``;
    this.weekDaysName.forEach(day => makeupWeekDays += `<div class="datepicker__day-name">${day}</div>`);
    // Числа месяца
    let makeupDays = ``;
    daysArr.forEach(day => makeupDays += `
      <div
        class="datepicker__cell datepicker__cell-day ${day.class}"
        data-date="${day.day}"
        data-month="${day.month}"
        data-year="${day.year}">
        ${day.day}
      </div>`);
    this.$dpDay.innerHTML = `
      <div class="datepicker__days-names">
        ${makeupWeekDays}
      </div>
      <div class="datepicker__cells datepicker__cells-days">
        ${makeupDays}
      </div>
    `;
  }
  monthToHtml() {
    let str = `<div class="datepicker__cells datepicker__cells-months">`;
    this.monthShortName.forEach((month, index) => {
      let classes = index === this.monthCurrent && this.dateInput.getFullYear() === this.yearCurrent ? "-selected-" : "";
      let disabled = "";
      if (this.minDate) {
        disabled = this.minDate.year > this.yearCurrent ? " -disabled-" : this.minDate.year == this.yearCurrent && this.minDate.month > index ? " -disabled-" : "";
      }
      if (this.maxDate && disabled.length === 0) {
        disabled = this.maxDate.year < this.yearCurrent ? " -disabled-" : this.maxDate.year == this.yearCurrent && this.maxDate.month < index ? " -disabled-" : "";
      }
      str += `
        <div
          class="datepicker__cell datepicker__cell-month ${classes} ${disabled}"
          data-month="${index}"
          data-year="${this.yearCurrent}">
          ${month}
        </div>
      `;
    });
    str += "</div>";
    this.$dpMonth.innerHTML = str;
  }
  yearToHtml() {
    let str = `<div class="datepicker__cells datepicker__cells-years">`;
    for (let i = 8 * this.shiftYear - 4; i < 8 * (this.shiftYear + 1); i++) {
      let classes = this.yearCurrent - i === this.yearCurrent ? "-selected-" : "";
      let disabled = "";
      if (this.minDate) {
        disabled = this.minDate.year > this.yearCurrent + i ? " -disabled-" : "";
      }
      if (this.maxDate && disabled.length === 0) {
        disabled = this.maxDate.year < this.yearCurrent + i ? " -disabled-" : "";
      }
      str += `
        <div
          class="datepicker__cell datepicker__cell-year ${classes} ${disabled}"
          data-year="${this.yearCurrent + i}">
          ${this.yearCurrent + i}
        </div>
      `;
    }
    str += "</div>";
    this.$dpYear.innerHTML = str;
  }
  bottomNavToHtml() {
    return `
      <div
        class="btn-prev"
        id="dpPrev_${this.indexDatePicker}">
      </div>
      <div
        class="btn-next"
        id="dpNext_${this.indexDatePicker}">
      </div>
    `;
  }
  topNavToHtml() {
    let str = `
      <div
        class="btn-title"
        id="setView_${this.indexDatePicker}">
        ${this.view === "day" ? this.monthName[this.monthCurrent] : ""}
        ${this.yearCurrent}
      </div>
      <div
        class="btn-now"
        id="setNowDate_${this.indexDatePicker}">
        ${this.view === "day" ? this.messages.today : this.messages.current}
      </div>
    `;
    if (this.$dpNavTop && this.$dpNavTop.innerHTML) {
      this.$dpNavTop.innerHTML = str;
    }
  }
  parseSetDate() {
    let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.$input.dataset.set_date !== undefined && !str) {
      let arr = this.$input.dataset.set_date.split(this.separator);
      this.date = new Date(arr[2], arr[1] - 1, arr[0]);
      this.dateInput = new Date(arr[2], arr[1] - 1, arr[0]);
    }
    if (str) {
      let arr = str.split(this.separator);
      this.date = new Date(arr[2], arr[1] - 1, arr[0]);
      this.dateInput = new Date(arr[2], arr[1] - 1, arr[0]);
    }
    if (this.minDate.date > this.date) {
      this.date = this.dateInput = new Date(this.minDate.date);
    }
    if (this.maxDate.date < this.date) {
      this.date = this.dateInput = new Date(this.maxDate.date);
    }
  }
  setYear(e) {
    e.stopPropagation();
    if (e.target.dataset.year && !e.target.classList.contains("-disabled-")) {
      this.date.setFullYear(e.target.dataset.year);
      this.view = "month";
      this.emit("setDate");
      this.emit("changeView");
    }
  }
  setMonth(e) {
    e.stopPropagation();
    if (e.target.dataset.month && !e.target.classList.contains("-disabled-")) {
      this.date.setMonth(e.target.dataset.month);
      this.view = "day";
      this.emit("setDate");
      this.emit("changeView");
    }
  }
  setDay(e) {
    e.stopPropagation();
    if (e.target.dataset.date && !e.target.classList.contains("-disabled-")) {
      this.date = new Date(+e.target.dataset.year, +e.target.dataset.month, +e.target.dataset.date);
      this.emit("setDate");
      this.emit("changeView");
      // close view
      this.$root.classList.remove(this.classShow);
    }
  }
  setNowDate() {
    switch (this.view) {
      case "year":
        this.date.setFullYear(this.minDate.year > new Date().getFullYear() ? this.minDate.year : this.maxDate.year < new Date().getFullYear() ? this.maxDate.year : new Date().getFullYear());
        this.view = "month";
        this.emit("setDate");
        this.emit("changeView");
        break;
      case "month":
        this.date.setFullYear(this.minDate.year > new Date().getFullYear() ? this.minDate.year : this.maxDate.year < new Date().getFullYear() ? this.maxDate.year : new Date().getFullYear());
        this.date.setMonth(this.minDate.date > new Date(this.yearCurrent, new Date().getMonth()) ? this.minDate.month : this.maxDate.date < new Date(this.yearCurrent, new Date().getMonth()) ? this.maxDate.month : new Date().getMonth());
        this.view = "day";
        this.emit("setDate");
        this.emit("changeView");
        break;
      case "day":
        this.date = this.minDate.date > new Date() ? new Date(this.minDate.date) : this.maxDate.date < new Date() ? new Date(this.maxDate.date) : new Date();
        this.emit("setDate");
        this.emit("changeView");
        break;
    }
    this.$root.classList.remove(this.classShow);
  }
  setDateInput() {
    let isInitSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.minDate.date > this.date) {
      this.date = new Date(this.minDate.date);
    }
    if (this.maxDate.date < this.date) {
      this.date = new Date(this.maxDate.date);
    }
    this.dateInput = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate());
    this.$input.value = moment(this.date).toISOString(true).substring(0, 10);
    this.shiftYear = 0;

    //если в поле не текущая дата, которая была установлена при init()
    if (!isInitSet) {
      this.$input.dispatchEvent(new Event("change"));
    }
  }
  switchView() {
    this.$dpDay.classList.remove("active");
    this.$dpMonth.classList.remove("active");
    this.$dpYear.classList.remove("active");
    switch (this.view) {
      case "day":
        this.$dpDay.classList.add("active");
        this.$dpSetView.innerHTML = `${this.monthName[this.monthCurrent]} ${this.yearCurrent}`;
        this.$dpNowDate.innerHTML = this.messages.today;
        break;
      case "month":
        this.$dpMonth.classList.add("active");
        this.$dpSetView.innerHTML = this.yearCurrent;
        this.$dpNowDate.innerHTML = this.messages.current;
        break;
      case "year":
        this.$dpYear.classList.add("active");
        this.$dpSetView.innerHTML = this.yearCurrent;
        this.$dpNowDate.innerHTML = this.messages.current;
        break;
      default:
        this.$dpDay.classList.add("active");
        break;
    }
  }
  setView() {
    switch (this.view) {
      case "day":
        this.view = "month";
        break;
      case "month":
        this.view = "year";
        break;
      case "year":
      default:
        this.view = "day";
        break;
    }
    this.emit("changeView");
  }
  prevView() {
    switch (this.view) {
      case "year":
        this.shiftYear--;
        this.yearToHtml();
        break;
      case "month":
        this.date.setFullYear(--this.yearCurrent);
        this.emit("changeView");
        break;
      case "day":
        if (this.monthCurrent === 0) {
          this.date.setMonth(11);
          this.date.setFullYear(--this.yearCurrent);
        } else {
          this.date.setMonth(--this.monthCurrent);
        }
        this.emit("changeView");
        break;
      default:
        break;
    }
  }
  nextView() {
    switch (this.view) {
      case "year":
        this.shiftYear++;
        this.yearToHtml();
        break;
      case "month":
        this.date.setFullYear(++this.yearCurrent);
        this.emit("changeView");
        break;
      case "day":
        if (this.monthCurrent === 11) {
          this.date.setMonth(0);
          this.date.setFullYear(++this.yearCurrent);
        } else {
          this.date.setMonth(++this.monthCurrent);
        }
        this.emit("changeView");
        break;
      default:
        break;
    }
  }
  dateInputMask(e) {
    if (e.keyCode < 47 || e.keyCode > 57) {
      e.preventDefault();
    }
    const len = this.$input.value.length;
    if (len !== 1 || len !== 3) {
      if (e.keyCode === 47) {
        e.preventDefault();
      }
    }
    if (len === 2) {
      this.$input.value += this.separator;
    }
    if (len === 5) {
      this.$input.value += this.separator;
    }
  }
  inputSetDate() {
    if (this.$input.value.length === 10) {
      this.parseSetDate(this.$input.value);
      this.emit("setDate");
      this.emit("changeView");
    }
  }
  showDate() {
    let isAlreadyShow = false;
    if (this.$input.dataset.class_show) {
      this.classShow = this.$input.dataset.class_show;
    }
    this.$root.classList.forEach(classElem => {
      if (classElem === this.classShow) {
        isAlreadyShow = true;
      }
    });
    if (!isAlreadyShow && this.classShow) {
      this.$root.classList.add(this.classShow);
      if (!this.checkDateInputFreeUnderspace()) {
        //если не хватает места под полем ввода даты, показываем датапикер сверху от поля ввода
        this.$root.classList.add(`${this.classShow}-above`);
      }
    }
    this.$input.dispatchEvent(new Event("datepicker-show"));
  }
  hideDate(event) {
    let box = event.target.closest(`#root_datepicker-${this.indexDatePicker}`);

    //если нажали не на датапикер, то скрываем его, удаляя классы
    if (!box) {
      this.$root.classList.remove(this.classShow);
      if (this.$root.className.includes("above")) {
        this.$root.classList.remove(`${this.classShow}-above`);
      }
    }
  }
  checkDateInputFreeUnderspace() {
    //вычисляем, есть ли свободное пространство под полем ввода даты для отображения датапикера
    const dateInputCoords = this.$input.getBoundingClientRect();
    const dateInputBottomCoord = dateInputCoords.bottom;
    const dateInputUnderFreeSpace = document.documentElement.clientHeight - dateInputBottomCoord;
    const datePickerHeight = this.$datePickerRoot.clientHeight;
    const gap = 10; // дополнительная величина отступа от низа страницы

    return dateInputUnderFreeSpace > datePickerHeight + gap;
  }
  addListener() {
    // Выбор года
    this.$dpYear.addEventListener("click", this.setYear.bind(this));
    // Выбор месяца
    this.$dpMonth.addEventListener("click", this.setMonth.bind(this));
    // Выбор дня
    this.$dpDay.addEventListener("click", this.setDay.bind(this));
    // Выбор отображения
    this.$dpSetView.addEventListener("click", this.setView.bind(this));
    // установка текущего года/месяца/дня
    this.$dpNowDate.addEventListener("click", this.setNowDate.bind(this));
    // назад
    this.$dpPrev.addEventListener("click", this.prevView.bind(this));
    // вперед
    this.$dpNext.addEventListener("click", this.nextView.bind(this));
    // Что пишут
    this.$input.addEventListener("input", this.inputSetDate.bind(this));
    // Маска
    this.$input.addEventListener("keypress", this.dateInputMask.bind(this));
    // Открыть
    this.$input.addEventListener("click", this.showDate.bind(this));

    // Закрыть
    const modalOverlay = this.$datePickerRoot.closest(".form-overlay");
    if (!modalOverlay) {
      document.body.addEventListener("click", this.hideDate.bind(this));
    } else {
      modalOverlay.addEventListener("click", this.hideDate.bind(this));
    }
  }
  updateData() {
    let start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    this.weekDayCurrent = this.date.getDay(); // индекс дня недели текущей даты
    this.dayCurrent = this.date.getDate(); // день месяца текущей даты
    this.monthCurrent = this.date.getMonth(); // индекс месяца текущей даты
    this.yearCurrent = this.date.getFullYear(); // год текущей даты

    // кол-во дней текущего месяца
    this.maxDayCurrent = new Date(this.yearCurrent, this.monthCurrent + 1, 0).getDate();
    // кол-во дней предыдущего месяца
    this.maxDayPrev = new Date(this.yearCurrent, this.monthCurrent, 0).getDate();
    // индекс дня недели 1 числа текущего месяца
    this.weekDayStart = new Date(this.yearCurrent, this.monthCurrent, 1).getDay();
    // индекс дня недели последнего числа текущего месяца
    this.weekDayEnd = new Date(this.yearCurrent, this.monthCurrent, this.maxDayCurrent).getDay();
    if (!start) {
      this.dayToHtml();
      this.monthToHtml();
      this.yearToHtml();
    }
  }
  init() {
    // Название css класса показа пикера
    if (this.$input.dataset.class_show) {
      this.classShow = this.$input.dataset.class_show;
    }
    this.$datePickerRoot = document.createElement("div");
    this.$datePickerRoot.classList.add("qform-field__block_box__field__view");
    this.$datePickerRoot.innerHTML = this.toHtml();
    this.$box.append(this.$datePickerRoot);
    this.$dpNavTop = document.getElementById(`navTop_${this.indexDatePicker}`);
    this.topNavToHtml();
    this.$dpDay = document.getElementById(`datepickerDay_${this.indexDatePicker}`);
    this.$dpMonth = document.getElementById(`datepickerMonths_${this.indexDatePicker}`);
    this.$dpYear = document.getElementById(`datepickerYears_${this.indexDatePicker}`);
    this.$dpSetView = document.getElementById(`setView_${this.indexDatePicker}`);
    this.$dpNowDate = document.getElementById(`setNowDate_${this.indexDatePicker}`);
    this.$dpPrev = document.getElementById(`dpPrev_${this.indexDatePicker}`);
    this.$dpNext = document.getElementById(`dpNext_${this.indexDatePicker}`);
    this.dayToHtml();
    this.monthToHtml();
    this.yearToHtml();
    this.switchView();
    this.setDateInput(true);
    this.addListener();
    this.subscribe("changeView", this.updateData.bind(this));
    this.subscribe("changeView", this.switchView.bind(this));
    this.subscribe("setDate", this.setDateInput.bind(this));
    this.inputMask = this.$input.value;
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (!Array.isArray(this.listeners[event])) {
      return false;
    }
    this.listeners[event].forEach(listener => {
      listener(...args);
    });
    return true;
  }
  subscribe(event, fn) {
    this.listeners[event] = this.listeners[event] || [];
    this.listeners[event].push(fn);
    return () => {
      this.listeners[event] = this.listeners[event].filter(listener => listener !== fn);
    };
  }
}